module.exports = __webpack_public_path__ + "img/icon-add-blue.277536fa.svg";